/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconGem(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M3.779.583h8.163l3.918 4.895-8 9.7-8-9.7L3.78.583zm-1.495 5.5 3.947 4.786-1.316-4.786h-2.63zm2.88-1.5 1.42-2.5H4.479l-2.001 2.5h2.687zm1.282 1.5 1.414 5.144 1.414-5.144H6.446zm2.408-1.5-.994-1.75-.993 1.75h1.987zm1.951 1.5L9.49 10.87l3.946-4.786h-2.63zm2.438-1.5-2.002-2.5H9.137l1.419 2.5h2.687z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M5.807.999h12.29l5.855 7.216-12 14.357-12-14.357L5.808 1zM20.397 7l-3.246-4.001h-3.473L15.978 7h4.42zm-6.719 0-1.725-3-1.726 3h3.451zm-4.04 2 2.315 8.304L14.266 9H9.64zm-1.71-2 2.3-4.001H6.755L3.508 7h4.419zM3.209 9l6.542 7.827L7.571 9H3.208zm10.945 7.827L20.696 9h-4.361l-2.18 7.827z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconGem is deprecated and will be archived soon. Use IconGem instead.
 */
export function Experimental__IconGem(props) {
  return /*#__PURE__*/React.createElement(IconGem, props);
}